import { i18n } from 'src/i18n'

export class AppError extends Error {
  constructor(public codeStr: string) {
    super(codeStr)
    this.codeStr = codeStr
    Object.setPrototypeOf(this, AppError.prototype)
  }

  getLocalisedMessage() {
    return i18n(this.codeStr)
  }
}

export class UserError extends Error {
  constructor(public codeStr: string) {
    super(codeStr)
    this.codeStr = codeStr
    Object.setPrototypeOf(this, UserError.prototype)
  }

  getLocalisedMessage() {
    return i18n(this.codeStr)
  }
}

export class ApiError extends Error {
  constructor(public codeStr: string) {
    super(codeStr)
    this.codeStr = codeStr
    Object.setPrototypeOf(this, ApiError.prototype)
  }

  getLocalisedMessage() {
    return i18n(this.codeStr)
  }
}

export class ApiResultValidationError extends Error {
  constructor(public message: string) {
    super(message)
    Object.setPrototypeOf(this, ApiResultValidationError.prototype)
  }
}
